import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";
import { useSelector } from "react-redux";
import enLocale from "./translations/en.json";
import deLocale from "./translations/de.json";
import { IntlProvider } from "react-intl";
import { useEffect } from "react";

function App() {
  const lang = useSelector((state) => state.settings.lang);

  useEffect(() => {}, [lang]);

  return (
    <IntlProvider locale={lang} messages={lang === "en" ? enLocale : deLocale}>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </IntlProvider>
  );
}

export default App;
